import MoveHub from './MoveHub';
export default MoveHub;